// extracted by mini-css-extract-plugin
export default {"container":"PlayerScenario_container__IYcaP","settingsTrigger":"PlayerScenario_settingsTrigger__FlljF"};